/* eslint-disable react-hooks/exhaustive-deps */
/* ============================================================
   แผนโหลดสินค้า / การจองเรือ — หน้ารายการ

   ใช้แทนไฟล์ Excel sheet "LOAD" ที่คุมด้วยมือ
   ค้นหาตามช่วงวันโหลดเพื่อดูแผนรายสัปดาห์ได้
============================================================ */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card, Collapse, Form, Flex, Row, Col, Space, Select, Input, Button,
  Table, Typography, DatePicker, message,
} from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { MdOutlineLibraryAdd } from "react-icons/md";
import dayjs from "dayjs";

import { accessColumn, BOOKING_STATUS } from "./model";
import useColumnSettings from "../../../hooks/useColumnSettings";
import useAccessPageState from "../../../hooks/useAccessPageState";
import ShipmentPlanService from "../../../service/ERP/ShipmentPlan.service";

const spService = ShipmentPlanService();
const { RangePicker } = DatePicker;

const mngConfig = { title: "", action: "create", code: null };

const ShipmentPlanAccess = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [accessData, setAccessData] = useState([]);
  const [activeSearch, setActiveSearch] = useState([]);
  const {
    tablePagination,
    saveState,
    restoreState,
    clearState,
    restoreDefaultPagination,
    handleTableChange,
  } = useAccessPageState({ form });

  const handleSearch = (forcedValues = null, paginationOverride = null) => {
    const runSearch = (v) => {
      saveState(v, paginationOverride ?? tablePagination);
      const data = { ...v };
      if (data.load_date?.length === 2) {
        data.load_date_from = dayjs(data.load_date[0]).format("YYYY-MM-DD");
        data.load_date_to = dayjs(data.load_date[1]).format("YYYY-MM-DD");
      }
      delete data.load_date;

      spService
        .search(data, { ignoreLoading: Object.keys(data).length !== 0 })
        .then((res) => setAccessData(res.data?.data || []))
        .catch(() => message.error("Request error!"));
    };

    if (useAccessPageState.canUseForcedSearchValues(forcedValues)) {
      runSearch(forcedValues);
      return;
    }
    form.validateFields().then(runSearch);
  };

  const handleClear = () => {
    clearState();
    form.resetFields();
    handleSearch({}, restoreDefaultPagination());
  };

  const handleAdd = () =>
    navigate("manage/create", {
      state: { config: { ...mngConfig, title: "เพิ่มแผนโหลด", action: "create" } },
    });

  const handleView = (data) =>
    navigate("manage/view", {
      state: {
        config: {
          ...mngConfig,
          title: "View แผนโหลดสินค้า / จองเรือ",
          action: "view",
          code: data?.id,
        },
      },
    });

  const handleEdit = (data) =>
    navigate("manage/edit", {
      state: {
        config: { ...mngConfig, title: "แก้ไขแผนโหลด", action: "edit", code: data?.id },
      },
    });

  const handleOpenJo = (jocode) =>
    navigate("/ERP/job-order/view", {
      state: { config: { title: "View", code: jocode, action: "view" } },
    });

  const handleDelete = (data) => {
    spService
      .deleted(data.id)
      .then(() => {
        message.success("ลบเรียบร้อย");
        setAccessData((prev) => prev.filter((d) => d.id !== data.id));
      })
      .catch((err) => message.error(err?.response?.data?.message || "ลบไม่สำเร็จ"));
  };

  useEffect(() => {
    const restored = restoreState();
    handleSearch(restored?.searchValues ?? null, restored?.tablePagination);
  }, []);

  const FormSearch = (
    <Collapse
      size="small"
      onChange={setActiveSearch}
      bordered={false}
      activeKey={activeSearch}
      items={[
        {
          key: "1",
          label: (
            <>
              <SearchOutlined />
              <span> ค้นหา</span>
            </>
          ),
          children: (
            <Form form={form} layout="vertical" autoComplete="off">
              <Row gutter={[8, 8]}>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item label="ช่วงวันโหลด" name="load_date">
                    <RangePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={4}>
                  <Form.Item label="Job No." name="jocode">
                    <Input placeholder="กรอก Job No." />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={4}>
                  <Form.Item label="INV No." name="inv_code">
                    <Input placeholder="กรอกเลขที่ Invoice" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={4}>
                  <Form.Item label="Booking No." name="booking_no">
                    <Input placeholder="กรอก Booking No." />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item label="ลูกค้า" name="cusname">
                    <Input placeholder="กรอกชื่อลูกค้า" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item label="สถานะ" name="booking_status">
                    <Select
                      allowClear
                      placeholder="ทั้งหมด"
                      options={BOOKING_STATUS.map((s) => ({ value: s, label: s }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item label="ชื่อเรือ" name="vessel">
                    <Input placeholder="กรอกชื่อเรือ" />
                  </Form.Item>
                </Col>
              </Row>
              <Flex justify="flex-end" gap={8}>
                <Button
                  type="primary"
                  size="small"
                  className="bn-action"
                  icon={<SearchOutlined />}
                  onClick={() => handleSearch()}
                >
                  ค้นหา
                </Button>
                <Button
                  type="primary"
                  size="small"
                  danger
                  className="bn-action"
                  icon={<ClearOutlined />}
                  onClick={handleClear}
                >
                  ล้าง
                </Button>
              </Flex>
            </Form>
          ),
          showArrow: false,
        },
      ]}
    />
  );

  const allColumns = accessColumn({ handleView, handleEdit, handleDelete, handleOpenJo });
  const { columns: column, settingsButton } = useColumnSettings(
    "shipment_plan_access_cols",
    allColumns
  );

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Typography.Title className="m-0 !text-zinc-800" level={3}>
          แผนโหลดสินค้า / จองเรือ
        </Typography.Title>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={8} justify="end">
          {settingsButton}
          <Button
            size="small"
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<MdOutlineLibraryAdd style={{ fontSize: ".9rem" }} />}
            onClick={handleAdd}
          >
            เพิ่มแผนโหลด
          </Button>
        </Flex>
      </Col>
    </Flex>
  );

  return (
    <div className="shipment-plan-access">
      <Space direction="vertical" size="middle" style={{ display: "flex", position: "relative" }}>
        {FormSearch}
        <Card>
          <Table
            title={() => TitleTable}
            size="small"
            rowKey="id"
            columns={column}
            dataSource={accessData}
            pagination={tablePagination}
            onChange={handleTableChange}
            scroll={{ x: "max-content" }}
          />
        </Card>
      </Space>
    </div>
  );
};

export default ShipmentPlanAccess;
